import styled from 'styled-components';

export const ManageUserPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem 0;

  h1 {
    margin-top: 1rem;
    font: 600 0.9rem/1rem 'Segoe UI', sans-serif;
  }
`;

export const SubscriptionItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-top: 1px solid ${({ theme }: {theme: any}) => theme.themePrimary};
  padding: 0.5rem 0;
  margin-top: 1rem;

  h2 {
    font: 600 1rem/1rem 'Segoe UI', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.themeDark};
  }

  h3 {
    font: 700 0.9rem/1rem 'Segoe UI', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.neutralTertiary};
    margin-top: 0.5rem;
  }

  .subscriptionType {
    h2 {
      margin-bottom: 0.5rem;
    }
  }

  .apps {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const AppSubscriptionItem = styled.div`
  display: grid;
  grid-template-columns: 2rem auto;
  gap: 0 1rem;

  i {
    grid-column: 1/2;
    grid-row: span 2;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 1rem;
    width: 2rem;
    height: 2rem;
    object-fit: contain;
    padding: 0.3rem;
    background: ${({ theme }: {theme: any}) => theme.themePrimary};
    color: #fff;
  }

  h3 {
    color: ${({ theme }: {theme: any}) => theme.black};
  }

  p {
    font: 300 0.75rem/0.75rem 'Segoe UI', sans-serif;
  }
`;
